<template>
  <HonorPCMain v-if="!this.$store.state.page.isMobile"></HonorPCMain>
  <MobileHonorMain v-else></MobileHonorMain>
</template>

<script>
import HonorPCMain from './HonorSlotPC.vue';
import MobileHonorMain from './HonorSlotMobile.vue';

export default {
  name: "HonorMain",
  components: {
    HonorPCMain,
    MobileHonorMain,
  },
};
</script>